import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../../Styles/Admin/LoginPage.css';
import API_BASE_URL from '../../config';

export default function AddAccount() {
  const [form, setForm] = useState({ email: '', password: '', name: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await axios.post(`${API_BASE_URL}/api/users`, form);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Failed to create account. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="login-main-bg">
      <div className="login-main-container">
        {/* Left Blue Section */}
        <div className="login-left">
          <img src="/New_logo.jpg" alt="Outstanding Workplaces Logo" className="login-logo" />
          <img src="/login_img.png" alt="Login Illustration" className="login-illustration-img" />
        </div>
        {/* Right White Section */}
        <div className="login-right">
          <div className="login-form-box">
            <h2 className="login-title">Add New Account</h2>
            <p className="login-subtitle">Fill the form to create a new admin account</p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Profile Name"
                value={form.name}
                onChange={handleChange}
                required
                className="login-input"
              />
              <input
                type="text"
                name="email"
                placeholder="Email/User Name"
                value={form.email}
                onChange={handleChange}
                required
                className="login-input"
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
                required
                className="login-input"
              />
              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? 'Creating...' : 'Sign up'}
              </button>
              {error && <div className="login-error">{error}</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}